var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c(
            "v-card",
            { staticClass: "mb-20 px-4", attrs: { flat: "" } },
            [
              _c("v-divider"),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.items,
                  "server-items-length": _vm.totalItems,
                  "footer-props": _vm.footerProps,
                  options: _vm.options,
                  loading: _vm.loader,
                  "show-expand": "",
                  "single-expand": ""
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.status",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("icon-tooltip", {
                          attrs: { options: _vm.getStatus(item.status) }
                        })
                      ]
                    }
                  },
                  {
                    key: "item.created_at",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                          _vm._v(_vm._s(_vm._f("dateAndTime")(item.created_at)))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.title",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                          _vm._v(
                            _vm._s(_vm._f("formatTitle")(item.title, "title"))
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.message",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatMessage")(item.message, "message")
                            )
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "expanded-item",
                    fn: function(ref) {
                      var headers = ref.headers
                      var item = ref.item
                      return [
                        _c("td", { attrs: { colspan: headers.length } }, [
                          _c("p", { staticClass: "mt-5" }, [
                            _c("b", [_vm._v("ID:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(item.id) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("b", [_vm._v("TITULO:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("b", [_vm._v("MENSAGEM:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(item.message) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("b", [_vm._v("STATUS:")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("getNotificationStatus")(
                                    item.status,
                                    "name"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-987ac1fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987ac1fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/List/Sent.vue
// module id = null
// module chunks = 